'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Breadcrumb;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _list = require('../list');

require('./breadcrumb.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Breadcrumb Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */

// components
function Breadcrumb(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;

    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-breadcrumb': true
    }, '' + className, className));

    return (0, _jsx3.default)(_list.List, {
        isInline: true,
        spacing: 'small',
        className: classNames,
        id: id
    }, void 0, children);
}
// css
//# sourceMappingURL=Breadcrumb.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/breadcrumb/Breadcrumb.js
// module id = 547
// module chunks = 0